module.exports = __webpack_public_path__ + "img/olpmc.addcdf30.png";